<template>
  <div class="bind-card-page">
    <GreetingCard
      :visible="showGreetingCard"
      :card-image="currentGreetingCard?.imageUrl"
      :blessing="currentGreetingCard?.blessing"
      :need-signature="currentGreetingCard?.needSignature === '1'"
      @button-click="handleGreetingCardButtonClick"
    />
    <SignaturePad
      :visible="showSignature"
      :signature-options="signatureOptions"
      @close="closeSignature"
      @confirm="handleSignatureConfirm"
    />

    <div class="bind-card-page__body">
      <div class="bind-card-page__hero">
        <div class="bind-card-page__icon">
          <van-icon name="coupon-o" size="1.75rem" color="#d33b2e" />
        </div>
        <h1 class="bind-card-page__title">券密绑定</h1>
        <p class="bind-card-page__desc">请输入卡/券号与密码完成绑定</p>
      </div>

      <van-form class="bind-card-form" :scroll-to-error="false" @submit="onSubmit">
        <div class="bind-card-form__card">
          <div class="bind-card-form__field">
            <label class="bind-card-form__label">
              <van-icon name="credit-pay" size="0.9rem" />
              <span>券号</span>
            </label>
            <van-field
              v-model="form.cardNo"
              class="bind-card-form__input"
              type="text"
              inputmode="numeric"
              maxlength="16"
              autocomplete="off"
              :border="false"
              placeholder="请输入卡/券号"
              :rules="[{ required: true, message: '请输入卡/券号' }]"
            />
          </div>

          <div class="bind-card-form__field">
            <label class="bind-card-form__label">
              <van-icon name="lock" size="0.9rem" />
              <span>密码</span>
            </label>
            <van-field
              v-model="form.cardPwd"
              class="bind-card-form__input"
              type="text"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              :border="false"
              placeholder="请输入6位密码"
              :rules="[{ required: true, message: '请输入密码' }]"
            />
          </div>
        </div>

        <van-button
          block
          round
          native-type="submit"
          class="bind-card-form__submit"
        >
          立即绑定
        </van-button>
      </van-form>

      <div class="bind-card-tips">
        <p class="bind-card-tips__title">温馨提示</p>
        <ul class="bind-card-tips__list">
          <li>卡/券不记名，丢失无法找回，卡/券绑定后不支持解绑!</li>
          <li>卡/券过期后不支持绑定，请在有效期内使用!</li>
          <li>兑换商品后可通过“我的订单”查询物流状态及订单信息!</li>
          <li>客服热线:400-001-6621(9:00-21:00)</li>
        </ul>
      </div>
    </div>

    <BindGetKnow v-if="show" :cardDate="cardDate" @closed="closeds" @sured="sured" />
  </div>
</template>

<script>
import BindGetKnow from '../../components/card/BindGetKnow';
import GreetingCard from './components/GreetingCard.vue';
import SignaturePad from './components/SignaturePad.vue';

export default {
  name: 'BindCard',
  components: { BindGetKnow, GreetingCard, SignaturePad },
  data() {
    return {
      form: {
        cardNo: '',
        cardPwd: '',
        userId: '',
        ticketType: '',
        flag: false,
      },
      show: false,
      cardDate: null,
      showGreetingCard: false,
      showSignature: false,
      signatureOptions: {
        penColor: '#000000',
        backgroundColor: '#f5f5f5',
      },
      currentGreetingCard: null,
    };
  },
  mounted() {
    if (localStorage.getItem('userInfo')) {
      this.form.userId = JSON.parse(localStorage.getItem('userInfo')).id;
    }
    this.form.ticketType = this.$route.query.ticketType;
  },
  methods: {
    closeds() {
      this.show = false;
    },
    onSubmit() {
      this.$api
        .checkBenefitCard(this.form)
        .then((res) => {
          if (res.code == 0) {
            this.cardDate = res.data;
            this.show = true;
          } else {
            this.$Toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sured() {
      this.$api
        .bindCard(this.form)
        .then((res) => {
          this.$Toast(res.msg);
          if (res.code == 0) {
            this.show = false;
            if (this.cardDate && this.cardDate.showGreetingCard === '1') {
              this.currentGreetingCard = this.cardDate;
              this.showGreetingCard = true;
            } else {
              localStorage.setItem('cardback', true);
              window.history.back();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleGreetingCardButtonClick() {
      if (!this.currentGreetingCard) return;
      if (this.currentGreetingCard.needSignature === '1') {
        this.showSignature = true;
      } else {
        this.saveGreetingCardSignature(null);
      }
    },
    saveGreetingCardSignature(signatureDataURL) {
      if (!this.currentGreetingCard) return;
      const params = {
        spuId: this.currentGreetingCard.spuId,
        cardId: this.currentGreetingCard.cardId,
      };
      if (signatureDataURL) {
        params.signatureImage = signatureDataURL.includes(',')
          ? signatureDataURL.split(',')[1]
          : signatureDataURL;
      }
      this.$api
        .saveGreetingCardSignature(params)
        .then((res) => {
          if (res.code === 0) {
            this.$Toast.success('签收成功');
            this.showSignature = false;
            this.showGreetingCard = false;
            this.currentGreetingCard = null;
            localStorage.setItem('cardback', true);
            window.history.back();
          } else {
            this.$Toast.fail(res.msg || '签收失败');
          }
        })
        .catch((err) => {
          this.$Toast.fail('签收失败');
          console.error('保存签收记录失败:', err);
        });
    },
    closeSignature() {
      this.showSignature = false;
    },
    handleSignatureConfirm(signatureDataURL) {
      this.saveGreetingCardSignature(signatureDataURL);
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-card-page {
  min-height: 100vh;
  background: #f5f6f8;
}

.bind-card-page__body {
  padding: 1.25rem 1rem 2rem;
}

.bind-card-page__hero {
  text-align: center;
  padding: 0.5rem 0 1.25rem;
}

.bind-card-page__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  margin-bottom: 0.75rem;
  border-radius: 50%;
  background: #fff5f4;
  box-shadow: 0 4px 12px rgba(211, 59, 46, 0.1);
}

.bind-card-page__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.bind-card-page__desc {
  margin: 0.4rem 0 0;
  font-size: 0.8125rem;
  color: #999;
}

.bind-card-form__card {
  background: #fff;
  border-radius: 0.875rem;
  padding: 1rem 1rem 0.25rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

.bind-card-form__field {
  margin-bottom: 1rem;
}

.bind-card-form__label {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.45rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;

  .van-icon {
    color: #d33b2e;
  }
}

.bind-card-form__input {
  padding: 0.75rem 0.9rem;
  min-height: 2.75rem;
  background: #fff;
  border-radius: 0.625rem;
  border: 1px solid #e8e8e8;
  box-sizing: border-box;

  &::after {
    display: none;
  }

  :deep(.van-field__control) {
    font-size: 0.9375rem;
    color: #222;

    &::placeholder {
      color: #bbb;
    }
  }

  :deep(.van-field__error-message) {
    margin-top: 0.35rem;
    padding-left: 0.1rem;
    font-size: 0.75rem;
  }

  &:focus-within {
    border-color: #d33b2e;
  }
}

.bind-card-form__submit {
  height: 2.75rem;
  margin-top: 1.25rem;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #ff8a4c 0%, #d33b2e 100%);
  box-shadow: 0 4px 12px rgba(211, 59, 46, 0.22);
}

.bind-card-tips {
  margin-top: 1.25rem;
  padding: 0.875rem 1rem;
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.bind-card-tips__title {
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #666;
}

.bind-card-tips__list {
  margin: 0;
  padding-left: 1rem;
  font-size: 0.75rem;
  color: #999;
  line-height: 1.6;

  li + li {
    margin-top: 0.25rem;
  }
}
</style>
